<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      center
      @close="closeWindow"
    >
      <el-form
        :rules="rules"
        ref="ruleForm"
        label-position="left"
        :model="form"
        label-width="100px"
      >
        <el-form-item label="联系人*" prop="people">
          <el-input v-model="form.people" placeholder="请输入您的称呼" />
        </el-form-item>
        <el-form-item label="联系人电话*" prop="tel">
          <div class="getCode">
            <el-input v-model="form.tel" placeholder="请输入您的手机号" />
            <div class="codeCoin" @click="changeCode">
              <span v-if="show">获取验证码</span>
              <span v-else>重新发送({{ count }}s)</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="验证码*" prop="code">
          <el-input
            v-model="form.code"
            :disabled="disabled"
            placeholder="请输入短信验证码"
          />
        </el-form-item>
        <el-form-item label="电子邮件*" prop="emai">
          <el-input v-model="form.emai" placeholder="请输入您的电子邮箱" />
        </el-form-item>
        <el-form-item label="需求内容*" prop="text" v-if="type == '关于我们'">
          <el-input v-model="form.text" placeholder="请写需求或意向内容" />
        </el-form-item>
        <el-form-item label="企业名称*" prop="company" v-if="type == '其他'">
          <el-input v-model="form.company" placeholder="请写输入企业名称" />
        </el-form-item>
        <el-checkbox v-model="form.checked">阅读并接受政策</el-checkbox>

        <div class="bth_sumbile" @click="sumblie('ruleForm')">
          <div class="bth_sumbile_text">提交</div>
        </div>
      </el-form>
      <div class="dialog_box_bottom">客服咨询:0571-82672616</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    rules: Object,
    form: Object,
    type: String,
    dialogVisible: Boolean,
    title: String
  },
  data() {
    return {
      show: true,
      timer: null, //设置计时器,
      count: "",
      disabled: true
    };
  },
  created() {},
  mounted() {},
  methods: {
    closeWindow() {
      this.$emit("closeWindow");
    },
    sumblie(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.form.checked) {
            alert("submit!");
          } else {
            this.$alert("请勾选", {
              confirmButtonText: "确定",
              callback: action => {
                this.$message({
                  type: "info",
                  message: `action: ${action}`
                });
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeCode() {
      this.disabled = false;
      let TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;

        this.show = false;

        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    }
  }
};
</script>

<style scoped scoped lang="less">
/* 进入 */
.dialog-fade-enter-active {
  animation: anim-open 0.3s !important;
}

/* 离开 */
.dialog-fade-leave-active {
  animation: anim-close 0.3s !important;
}

@keyframes anim-open {
  0% {
    transform: translate(45%, -45%) scale(0);
  }
}

@keyframes anim-close {
  100% {
    transform: translate(45%, -45%) scale(0);
  }
}
/deep/ .el-input.is-disabled .el-input__inner {
  background: none;
  border-bottom: solid 1px #6d6a6a;
}
/deep/ .el-checkbox__inner {
  background: none;
}
.getCode {
  position: relative;
  .codeCoin {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
  }
}
/deep/ .el-input__inner {
  border-top: none;
  border-left: none;
  border-right: none;
  background: none;
  border-bottom: solid 1px #6d6a6a;
  color: #fff;
}
/deep/ .el-dialog {
  background: #000;
  border-radius: 30px;
  .el-dialog__title {
    color: #fff;
    font-size: 30px;
  }
  .el-form-item {
    margin-top: 40px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
  .el-form-item__label {
    color: #fff;
  }
}

.bth_sumbile {
  color: #fff;
  width: 100%;
  height: 60px;
  text-align: center;
  margin-top: 30px;

  .bth_sumbile_text {
    width: 120px;
    height: 50px;
    line-height: 50px;
    border: solid 1px #fff;
    color: #fff;
    border-radius: 30px;
    margin: auto;
    cursor: pointer;
  }
}
.dialog_box_bottom {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #4b4949;
  text-align: center;
  color: #b7b5b5;
  position: absolute;
  font-size: 20px;
  left: 0;
  bottom: 0;
  border-radius: 0 0 30px 30px;
}
/deep/ .el-dialog--center .el-dialog__body {
  padding-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/public/dialog.vue